import endpoints from "../constants/env/middletier";
import React, { useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import AddProjectForm from '../components/AddProjectForm';
import { useProject } from "../context/ProjectContextProvider";
import ProjectContextDropdown from '../components/ProjectContextDropdown';
import { useAuth } from '../AuthProvider'

export default function CxProjectsPage() {
    const [allProjects, setAllProjects] = useState([]);
    const [projectLookup, setProjectLookup] = useState([]);

    const { project, setProject } = useProject();
    const [columnExpanded, setColumnExpanded] = useState(false);
    const [addProjectFormVisible, setAddProjectFormVisible] = useState(false);
    const { keycloak } = useAuth()

    const [columns, setColumns] = useState([
        {field: 'name', header: 'Name'},
        {field: 'key', header: 'Key'},
        {field: 'type', header: 'Project Type'},
        {field: 'status', header: 'Status'},
        {field: 'createdAt  ', header: 'Created At'}
    ]);

    const sortByName = (a, b) => a.name.localeCompare(b.name);

    const fetchProjects = async () => {
        try {
            await keycloak.updateToken(30);

            const response = await fetch(`${endpoints.cxprojectraw}`, {
            // const response = await fetch(endpoints["cxprojectraw"], {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!response.ok) throw new Error("Bad response");
            const data = await response.json();
            const newSource = [...data].sort(sortByName);

            setAllProjects(newSource);

            const lookupResponse = await fetch(`${endpoints.projectslookup}`, {
            // const lookupResponse = await fetch(endpoints["projectslookup"], {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${keycloak.token}`,
                },
            });

            if (!lookupResponse.ok) throw new Error("Bad response");
            const lookupData = await lookupResponse.json();

            setProjectLookup(lookupData);

            // The following helps if the user is uploading their first project
            // If there is only one project, set the global project context variable to that one.
            if(newSource.length === 1) {
                const dropdownProject = lookupData.find(p => p.value === newSource[0].id);
                setProject(dropdownProject);
            }
        } catch (error) {
            console.error("Failed to fetch clients:", error);
        }
    };

    useEffect(() => {
        fetchProjects();
    }, []);

    const handleAddColumns = async (e) => {
        e.preventDefault();

        try {
            if(columnExpanded){
                setColumns(prev => [
                    {field: 'name', header: 'Name'},
                    {field: 'key', header: 'Key'},
                    {field: 'type', header: 'Project Type'},
                    {field: 'status', header: 'Status'}
                ]);
                setColumnExpanded(false);
            } else {
                setColumns(prev => [
                    ...prev,
                    {field: 'address1', header: 'Address 1'},
                    {field: 'address2', header: 'Address 2'},
                    {field: 'city', header: 'City'},
                    {field: 'state', header: 'State'},
                    {field: 'zip', header: 'Postal Code'},
                    {field: 'phase', header: 'Phase'},
                    {field: 'startDate', header: 'Start Date'},
                    {field: 'targetCompletionDate', header: 'End Date'},
                    {field: 'notes', header: 'Notes'}
                ]);
                setColumnExpanded(true);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
        } finally {
        }
    };

    const header = (
        <div className="flex align-items-center justify-content-between">
            <span className="text-xl text-900 font-bold">
                Projects
            </span>

            <div className="p-inputgroup" style={{ width: 'auto' }}>
                <Button icon="pi pi-plus" rounded text severity="secondary" onClick={() => setAddProjectFormVisible(true)} />
                <Button icon="pi pi-refresh" rounded text severity="secondary" onClick={() => fetchProjects()} />
                <Button icon={columnExpanded ? 'pi pi-caret-left' : 'pi pi-caret-right'}  label={columnExpanded ? 'Less Columns...' : 'More Columns...'}
                        text severity="secondary" onClick={handleAddColumns} />
            </div>
        </div>
    );

    const onRowSelect = async (event) => {
        const dropdownProject = projectLookup.find(p => p.value === event.data.id);

        setProject(dropdownProject);
    };

    const handleProjectSelection = async (e) => {
    };

    return (
        <>
        {allProjects && allProjects.length > 0 && (<ProjectContextDropdown onProjectChange={handleProjectSelection} />)}
            <br />

            <div className="card">
                <DataTable value={allProjects} header={header} tableStyle={{ minWidth: '50rem' }}
                           selectionMode="single" selection={project}
                           onRowSelect={onRowSelect}
                            dataKey="value"
                           scrollable>
                    {columns.map((col, i) => (
                        <Column key={col.field} field={col.field} header={col.header} style={{ minWidth: '150px' }} />
                    ))}
                </DataTable>
            </div>

            <AddProjectForm
                addProjectFormVisible={addProjectFormVisible}
                setAddProjectFormVisible={setAddProjectFormVisible}
            />

        </ >
    );
}